<!--
 * @Author: DY
 * @Date: 2024-11-20 18:46:12
 * @LastEditTime: 2025-03-19 14:03:12
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\sales\deliverGoodsTransportationDocument\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="deliverGoodsTransportationDocumentForm commonFormStyles">
            <HeaderNav :header-title="headerTitle" left-icon-name="2" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <van-tabs class="currencyTabsStyle" v-model="tabActive">
                <template v-if="transportType == 0">
                    <van-tab title="基础信息表" name="1">
                        <van-collapse v-model="activeNames">
                            <van-collapse-item name="1">
                                <div slot="title" class="title">
                                    <i class="iconfont icondingdan"></i>基本信息
                                </div>
                                <div class="formList">
                                    <van-cell title="铁运单号" :value="basicInfo.TransportNumber" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                                    <van-cell title="95306运单号" :value="basicInfo.Number95306" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                                    <van-cell title="车种车号" :value="basicInfo.RailwayTypeNumber" :icon="require('@/assets/images/icons/icon_18@2x.png')"></van-cell>
                                    <van-cell title="运到期限" :value="basicInfo.TransportPeriod" :icon="require('@/assets/images/icons/icon_36@2x.png')"></van-cell>
                                    <van-cell title="货区" :value="basicInfo.GoodsArea" :icon="require('@/assets/images/icons/icon_6@2x.png')"></van-cell>
                                    <van-cell title="货位" :value="basicInfo.GoodsLocation" :icon="require('@/assets/images/icons/icon_6@2x.png')"></van-cell>
                                    <van-cell title="请车日期" :value="basicInfo.ApplyDate" :icon="require('@/assets/images/icons/icon_7@2x.png')"></van-cell>
                                    <van-cell title="装车日期" :value="basicInfo.LoadingDate" :icon="require('@/assets/images/icons/icon_7@2x.png')"></van-cell>
                                    <van-cell title="车皮数量" :value="basicInfo.RailwayWagons" :icon="require('@/assets/images/icons/icon_16@2x.png')"></van-cell>
                                    <van-cell title="状态" :value="basicInfo.StatusName" :icon="require('@/assets/images/icons/icon_13@2x.png')"></van-cell>
                                </div>
                            </van-collapse-item>
                            <van-collapse-item name="2">
                                <div slot="title" class="title">
                                    货运信息
                                </div>
                                <div class="formList">
                                    <van-cell title="发站" :value="basicInfo.LeaveStation" :icon="require('@/assets/images/icons/icon_3@2x.png')"></van-cell>
                                    <van-cell title="到站" :value="basicInfo.ArriveStation" :icon="require('@/assets/images/icons/icon_3@2x.png')"></van-cell>
                                    <van-cell title="托运人姓名" :value="basicInfo.ConsignorName" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                                    <van-cell title="托运人电话" :value="basicInfo.ConsignorPhone" :icon="require('@/assets/images/icons/icon_9@2x.png')"></van-cell>
                                    <van-cell title="托运人住址" :value="basicInfo.ConsignorAddress" :icon="require('@/assets/images/icons/icon_3@2x.png')"></van-cell>
                                    <van-cell title="收货人姓名" :value="basicInfo.ReceiverName" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                                    <van-cell title="收货人电话" :value="basicInfo.ReceiverPhone" :icon="require('@/assets/images/icons/icon_9@2x.png')"></van-cell>
                                    <van-cell title="收货人住址" :value="basicInfo.ReceiverAddress" :icon="require('@/assets/images/icons/icon_3@2x.png')"></van-cell>
                                    <van-cell title="登记人" :value="basicInfo.Creator" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                                    <van-cell title="登记时间" :value="basicInfo.CreationTime" :icon="require('@/assets/images/icons/icon_7@2x.png')"></van-cell>
                                </div>
                            </van-collapse-item>
                        </van-collapse>
                    </van-tab>
                </template>
                <template v-else>
                    <van-tab title="基础信息表" name="1">
                        <van-collapse v-model="activeNames">
                            <van-collapse-item name="1">
                                <div slot="title" class="title">
                                    <i class="iconfont icondingdan"></i>基本信息
                                </div>
                                <div class="formList">
                                    <van-cell title="汽运单号" :value="basicInfo.TransportNumber" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                                    <template v-if="transportType == 2">
                                        <van-cell title="铁运单号" :value="basicInfo.RailwayNumber" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                                    </template>
                                    <van-cell title="发货通知单编号" :value="basicInfo.DeliveryNoticeNumber" :icon="require('@/assets/images/icons/icon_34@2x.png')"></van-cell>
                                    <van-cell title="合同编号" :value="basicInfo.ContractNo" :icon="require('@/assets/images/icons/icon_34@2x.png')"></van-cell>
                                    <van-cell title="客户名称" :value="basicInfo.ClientName" :icon="require('@/assets/images/icons/icon_1@2x.png')"></van-cell>
                                    <van-cell title="收货地址" :value="basicInfo.AddressMerge" :icon="require('@/assets/images/icons/icon_3@2x.png')"></van-cell>
                                    <van-cell title="签收人" :value="basicInfo.ClientContacts" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                                    <van-cell title="联系电话" :value="basicInfo.ClientContactsPhone" :icon="require('@/assets/images/icons/icon_9@2x.png')"></van-cell>
                                    <van-cell title="物料代码" :value="basicInfo.MaterialCode" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                                    <van-cell title="短描述" :value="basicInfo.MaterialShortName" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                                    <van-cell title="长描述" :value="basicInfo.MaterialName" :icon="require('@/assets/images/icons/icon_10@2x.png')"></van-cell>
                                    <van-cell title="单位" :value="basicInfo.MaterialUnit" :icon="require('@/assets/images/icons/icon_2@2x.png')"></van-cell>
                                    <van-cell title="运输方式" :value="$route.params.transportTypeStr" :icon="require('@/assets/images/icons/icon_11@2x.png')"></van-cell>
                                </div>
                            </van-collapse-item>
                            <van-collapse-item name="2">
                                <div slot="title" class="title">
                                    汽运信息
                                </div>
                                <div class="formList">
                                    <van-cell title="车牌号" :value="basicInfo.PlateNumber" :icon="require('@/assets/images/icons/icon_18@2x.png')"></van-cell>
                                    <van-cell title="发货日期" :value="basicInfo.DeliveryDate" :icon="require('@/assets/images/icons/icon_7@2x.png')"></van-cell>
                                    <van-cell title="司机" :value="basicInfo.DriverName" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                                    <van-cell title="司机电话" :value="basicInfo.DriverPhone" :icon="require('@/assets/images/icons/icon_9@2x.png')"></van-cell>
                                    <van-cell title="登记人" :value="basicInfo.Creator" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                                    <van-cell title="登记时间" :value="basicInfo.CreationTime" :icon="require('@/assets/images/icons/icon_36@2x.png')"></van-cell>
                                    <van-cell title="进场皮重（吨）" :value="basicInfo.DeliveryTareWeight" :icon="require('@/assets/images/icons/icon_6@2x.png')"></van-cell>
                                    <van-cell title="出场毛重（吨）" :value="basicInfo.DeliveryGrossWeight" :icon="require('@/assets/images/icons/icon_6@2x.png')"></van-cell>
                                    <van-cell title="出场净重（吨）" :value="basicInfo.DeliveryNetWeight" :icon="require('@/assets/images/icons/icon_6@2x.png')"></van-cell>
                                    <van-cell title="发货数量（吨）" :value="basicInfo.DeliveryWeight" :icon="require('@/assets/images/icons/icon_16@2x.png')"></van-cell>
                                    <van-cell title="备注" :value="basicInfo.Remarks" :icon="require('@/assets/images/icons/icon_10@2x.png')"></van-cell>
                                </div>
                            </van-collapse-item>
                        </van-collapse>
                    </van-tab>
                </template>
                <van-tab title="发货明细表" name="2">
                    <div class="deliveryDetailsTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>产品卡号</th>
                                    <th>短描述</th>
                                    <th>生产日期</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in detailedList" :key="index">
                                    <td>{{ item.ProductCardNumber }}</td>
                                    <td>{{ item.MaterialShortName }}</td>
                                    <td>{{ item.ProductDate }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </van-tab>
                <van-tab title="发货通知单" name="3" v-if="transportType == 0">
                    <div class="formList">
                        <van-cell title="发货通知单号" :value="deliveryNotice.DeliveryNoticeNumber" :icon="require('@/assets/images/icons/icon_28@2x.png')"></van-cell>
                        <van-cell title="合同编号" :value="deliveryNotice.ContractNo" :icon="require('@/assets/images/icons/icon_34@2x.png')"></van-cell>
                        <van-cell title="客户名称" :value="deliveryNotice.ClientName" :icon="require('@/assets/images/icons/icon_1@2x.png')"></van-cell>
                        <van-cell title="收货地址" :value="deliveryNotice.DeliveryAddress" :icon="require('@/assets/images/icons/icon_3@2x.png')"></van-cell>
                        <van-cell title="签收人名称" :value="deliveryNotice.ClientContacts" :icon="require('@/assets/images/icons/icon_8@2x.png')"></van-cell>
                        <van-cell title="联系电话" :value="deliveryNotice.ClientContactsPhone" :icon="require('@/assets/images/icons/icon_9@2x.png')"></van-cell>
                        <van-cell title="发货日期" :value="deliveryNotice.DeliveryDate" :icon="require('@/assets/images/icons/icon_7@2x.png')"></van-cell>
                    </div>
                </van-tab>
            </van-tabs>
            <footer class="currencyFooterStyle btns">
                <van-button type="primary" loading-type="spinner" @click="swiperright">
                    关闭
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'deliver-goods-transportation-document-form',
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            headerTitle: '',
            transportType: null,
            tabActive: '1',
            activeNames: ['1', '2', '3'],
            basicInfo: {},
            // detailedList: [],
            deliveryNotice: {},
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            this.transportType = this.$route.params.transportType;
            this.headerTitle = `发货单（${this.$route.params.transportTypeStr}）`;
            this.basicInfo = await this.getBasicInfoRequrst(this.$route.params.id) || {};
            this.detailedList = this.basicInfo.TransportTruckCards || this.basicInfo.RailwayCards || [];
            if (this.transportType === 0) {
                this.deliveryNotice = await this.getDeliveryNoticeRequrst(this.basicInfo.Id) || {};
            }
        },

        getBasicInfoRequrst(id) {
            let url = '';
            if (this.transportType === 0) {
                url = 'transport_railway_single';
            } else {
                url = 'transport_truck_single';
            }
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/${url}?id=${id}`);
        },
        getDeliveryNoticeRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_railway_single_notice?id=${id}`);
        },
    },
};
</script>
<style lang="stylus">
.deliverGoodsTransportationDocumentForm
    background: #f0f0f0;
    .currencyTabsStyle
        flex: 1
        height: 0
        .van-collapse
            padding 14rpx 0
        .van-tabs__content
            .van-tab__pane
                height: 100%
    .deliveryDetailsTable
        height: 100%
        overflow-y: auto
        padding 14rpx
        background: #fff
        table
            width 100%
            border-collapse: collapse
            th,td
                padding 0 5rpx
                height: 36rpx
                font-size: 14rpx
                color: #333333
                font-weight: 400
                border 1px solid #D7D7D7
            th
                background: #f2f5f6
            thead
                th
                    background #FBEEEE
                    border-color #EAD9D9
            tbody
                tr
                    &:nth-child(2n+1)
                        td
                            background: #F9FAFD
                td
                    background: #FFFFFF
                    text-align: center
</style>